import { IRecuperacaoContasReceberUseCase } from "../../../presentation/useCases/update/recuperacao_contas_receber_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * RecuperacaoContasReceberUseCase
 */

export class RecuperacaoContasReceberUseCase implements IRecuperacaoContasReceberUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async recuperacaoContasReceber(idsContaReceber: number[]): Promise<void> {
    await this.repository.recuperacaoContasReceber(idsContaReceber);

  }
}
